import React from 'react';
import { Icon } from '../../../../elements/icon';
import useCopy from '../useCopy';
import { HOWTO_IMAGES, GRANULES_SCALE } from '../assets';

export const HowToSlide = () => {
  const c = useCopy();

  return (
    <div className="s-howto">
      <h2>{c.rich('PC_Howto_Title')}</h2>
      <div className="ht-steps">
        {HOWTO_IMAGES.map((src, index) => (
          <div className="ht-step" key={src}>
            <img className="pc-img ht-img" alt="" src={src} />
            <b>{index + 1}</b>
            <span>{c.text(`PC_Howto_S${index + 1}`)}</span>
          </div>
        ))}
      </div>
      <div className="ht-lower">
        <div className="ht-alt">
          <img className="pc-img ht-scale" alt="" src={GRANULES_SCALE} />
          <span className="ht-or">{c.text('PC_Howto_Or')}</span>
        </div>
        <ul className="ht-rules">
          <li className="nop">
            <b>{c.text('PC_Howto_NoPills')}</b>
            <span>{c.text('PC_Howto_NoPillsSub')}</span>
          </li>
          <li className="yes">
            <i>
              <Icon raw name="productCarouselCheck" />
            </i>
            {c.text('PC_Howto_Yes')}
          </li>
        </ul>
      </div>
    </div>
  );
};
